export default function Pandas_Home() {
  return <div>Pandas_Home </div>;
}
